import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import {
  GetSessionRedirectStateV1Response,
  GetSessionSummaryResponse,
  UpdatePaymentV1Request,
  UpdateSessionOwnershipV1Request,
  UpdateSessionRedirectStateV1Request,
  UpdateTransactionStatusRequestV1,
  UpdateTransactionStatusResponseV1,
} from '../models';
import { SessionPayment } from '../models/session/session-payment.model';
import { UpdatePayableSessionRequestV1 } from '../models/session/update-payables-session-request-v1.model';

/* istanbul ignore next */
export abstract class SessionService {
  protected baseUrl: string;

  constructor(protected appConfig: AppConfigSettings) {
    this.baseUrl = this.appConfig.getconfig('sessionServiceUrl');
  }

  abstract updateTransactionStatusV1(
    tenantId: string,
    sessionId: string,
    updateTransactionStatusRequestV1: UpdateTransactionStatusRequestV1,
  ): Observable<UpdateTransactionStatusResponseV1>;

  abstract updatePaymentV1(
    tenantId: string,
    sessionId: string,
    updatePaymentRequest: UpdatePaymentV1Request,
  ): Observable<SessionPayment>;

  abstract getSessionSummaryResponseV1(
    tenantId: string,
    sessionId: string,
  ): Observable<GetSessionSummaryResponse>;

  abstract UpdateSessionPayablesSessionV1(
    tenantId: string,
    sessionId: string,
    payload: UpdatePayableSessionRequestV1,
  ): Observable<void>;

  abstract updateSessionRedirectStateV1(
    tenantId: string,
    sessionId: string,
    payload: UpdateSessionRedirectStateV1Request,
  ): Observable<void>;

  abstract getSessionRedirectStateV1(
    tenantId: string,
    sessionId: string,
  ): Observable<GetSessionRedirectStateV1Response>;

  abstract updateSessionOwnershipV1(
    tenantId: string,
    sessionId: string,
    payload: UpdateSessionOwnershipV1Request,
  ): Observable<void>;
}
